<style lang="scss">
  @use "../../assets/css/design-system/colors";
  @use "../../assets/css/design-system/utils";
  @use "../../assets/css/design-system/mixins";

  .sw-container {
    position: relative;
    display: inline-block;
  }

  .sw-dot {
    position: absolute;

    border-radius: 50%;
    border: utils.in_rem(1.5px) solid colors.get(interfaceWhite);

    width: utils.in_rem(12px);
    height: utils.in_rem(12px);

    // No dot for extra-small size
    &.small {
      bottom: utils.in_rem(-2px);
      right: utils.in_rem(-2px);
    }
    &.medium {
      bottom: utils.in_rem(-2px);
      right: utils.in_rem(-2px);
    }
    &.large {
      bottom: utils.in_rem(0px);
      right: utils.in_rem(-0.5px);
    }
    &.larger {
      bottom: utils.in_rem(0px);
      right: utils.in_rem(5px);
    }
    &.xl {
      bottom: utils.in_rem(6px);
      right: utils.in_rem(7.5px);
    }

    &.inactive {
      background-color: colors.get(primary_50);
    }

    &.active {
      background-color: colors.get(accentStatusSeaGreen);
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar {
    @include colors.utility_classes();
  }

  .avatar,
  img {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 50%;
    flex-shrink: 0;
    overflow: hidden;

    &.extra-small {
      width: utils.in_rem(16px);
      height: utils.in_rem(16px);
      @include mixins.h5();
      font-size: utils.in_rem(6px);
      font-weight: 600;
      line-height: 12px;
      letter-spacing: 0.0075rem;
    }

    &.small {
      width: utils.in_rem(24px);
      height: utils.in_rem(24px);
      @include mixins.h5();
    }

    &.medium {
      width: utils.in_rem(34px);
      height: utils.in_rem(34px);
      @include mixins.h4();
    }

    &.large {
      width: utils.in_rem(44px);
      height: utils.in_rem(44px);
      @include mixins.h3();
    }

    &.larger {
      width: utils.in_rem(60px);
      height: utils.in_rem(60px);
      @include mixins.h2();
    }

    &.xl {
      width: utils.in_rem(86px);
      height: utils.in_rem(86px);
      @include mixins.h1();
    }

    // for initials
    @include colors.color(
      textWhite,
      (
        background-color: colors.get(interfaceTransparentBlack_4),
      )
    );
    text-align: center;
    @include colors.background-color(
      primary_40,
      (
        background-color: colors.get(interfaceTransparentBlack_4),
      )
    );
  }
</style>

<script>
  import { toUtilityClasses } from "../tokens/utils";

  import Tooltip from "./Tooltip.svelte";

  export let size = "medium";
  export let src = "";
  export let firstName = "";
  export let lastName = "";
  export let backgroundColor = "";
  export let skeleton = false;

  // `candidateStatus` represents the status of a SW candidate/cached candidate
  // "inactive": candidate in SW but not actively on a campaign (could be finished though)
  // "active": candidate in SW and actively on a campaign
  // "" / "new": no SW status / candidate not in SW
  export let candidateStatus = "";
  export let tooltip = "";

  const wrappedCharAtZero = (s) => (s ? s.charAt(0) : "");

  const removeSrcIfError = (el) => {
    if (el) {
      el.addEventListener("error", () => {
        src = "";
      });
    }
  };

  $: initials = `${wrappedCharAtZero(firstName)}${wrappedCharAtZero(lastName)}`;
</script>

<div class="sw-container">
  <div
    class="avatar {size} {toUtilityClasses({ backgroundColor })}"
    class:skeleton
  >
    {#if src}
      <img use:removeSrcIfError {src} alt={initials || "avatar"} />
    {:else}
      {initials}
    {/if}
  </div>

  {#if ["active", "inactive"].includes(candidateStatus) && size !== "extra-small"}
    <Tooltip
      placement="bottom"
      let:onmouseenter
      let:onmouseleave
      let:onblur
      let:onfocus
    >
      <span slot="tooltip">{tooltip}</span>
      <div
        {onmouseenter}
        {onmouseleave}
        {onfocus}
        {onblur}
        role="button"
        tabindex="-1"
        class="sw-dot {candidateStatus} {size}"
      ></div>
    </Tooltip>
  {/if}
</div>
